var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairPersonalInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 6.62501C8.17831 6.62501 9.43751 5.36581 9.43751 3.8125C9.43751 2.2592 8.17831 1 6.625 1C5.0717 1 3.8125 2.2592 3.8125 3.8125C3.8125 5.36581 5.0717 6.62501 6.625 6.62501Z",
    stroke: "#664BF0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.9999V13.1874C1 12.1928 1.39509 11.239 2.09835 10.5357C2.80161 9.83248 3.75544 9.4374 4.75 9.4374H8.50001C8.81664 9.43451 9.13214 9.47547 9.43751 9.55922",
    stroke: "#664BF0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 16L16 13.1875L13.1875 10.375",
    stroke: "#664BF0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.1875H10.375",
    stroke: "#664BF0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairPersonalInfo);
export default __webpack_public_path__ + "static/media/pair-personal-info.838850fad18e14143019c872949eeca4.svg";
export { ForwardRef as ReactComponent };